import { FeatureFlags, isFeatureFlags } from '@/featureFlags/FeatureFlags';
import { HasKind, isHasKind } from '@/utilities/HasKind';

import { Crumbs } from '../bakery/Crumbs';

export const kind = 'FeatureFlagsChanged';

export interface FeatureFlagsChanged extends HasKind<typeof kind> {
  featureFlags: FeatureFlags;
}

export function crumble(action: FeatureFlagsChanged): Crumbs {
  return {
    // We're already logging all feature flags in `App`;
    // we can log only the replication-significant ones here, for convenience.
    syncEnhancements: action.featureFlags.syncEnhancements,
  };
}

export function isFeatureFlagsChanged(value: unknown): value is FeatureFlagsChanged {
  if (!isHasKind(kind, value)) return false;
  const possible = value as FeatureFlagsChanged;
  return isFeatureFlags(possible.featureFlags);
}
